module.exports = __webpack_public_path__ + "static/media/photo-14.26be77d5.webp";